import { render, staticRenderFns } from "./FriendVolunteerNetDetails.vue?vue&type=template&id=9936b826"
import script from "./FriendVolunteerNetDetails.vue?vue&type=script&lang=ts"
export * from "./FriendVolunteerNetDetails.vue?vue&type=script&lang=ts"
import style0 from "./FriendVolunteerNetDetails.vue?vue&type=style&index=0&id=9936b826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports